<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  metaInfo: {
    title: 'MEAD | Tudo para projetos de Ensino a Distância',
    titleTemplate: '%s',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'Tudo para projetos de Ensino a Distância' }
    ],
    htmlAttrs: {
      lang: 'pt-BR',
      amp: undefined
    }
  },
  components: {
    HelloWorld
  }
}
</script>
